// extracted by mini-css-extract-plugin
export var video = "Youtube-module--video--2Vx7s";